import axios from 'axios';

// iter 302 — átmeneti gateway-hibák (502/503/504/520-524, hálózati hiba) automatikus újrapróbálása GET-eknél,
// és állapot-esemény a „Kapcsolat helyreállítása…” sávnak.
const TRANSIENT = new Set([502, 503, 504, 520, 521, 522, 523, 524]);
const DELAYS = [800, 1800, 3500];
let degradedCount = 0;

const emit = () => window.dispatchEvent(new CustomEvent('acx-connection', { detail: { degraded: degradedCount > 0 } }));
const isTransient = (error) => (!error.response && error.code !== 'ERR_CANCELED') || TRANSIENT.has(error.response?.status);
const sleep = (ms) => new Promise((res) => setTimeout(res, ms));

export function installRetryInterceptor() {
  axios.interceptors.response.use(
    (r) => r,
    async (error) => {
      const cfg = error.config || {};
      const method = (cfg.method || 'get').toLowerCase();
      if (cfg._acxInner || !(method === 'get' || cfg.acxRetry) || !isTransient(error) || cfg.url?.includes('/api/copilot/')) {
        return Promise.reject(error);
      }
      degradedCount += 1; emit();
      let lastErr = error;
      try {
        for (const delay of DELAYS) {
          await sleep(delay);
          try {
            return await axios({ ...cfg, _acxInner: true });
          } catch (e) {
            lastErr = e;
            if (!isTransient(e)) break;
          }
        }
      } finally {
        degradedCount = Math.max(0, degradedCount - 1); emit();
      }
      return Promise.reject(lastErr);
    },
  );
}
